import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFavCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 44,
	height: 44,
	viewBox: "0 0 44 44",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M37.244 28.3143C38.0732 26.3124 38.5 24.1668 38.5 22C38.5 17.6239 36.7616 13.4271 33.6673 10.3327C30.5729 7.23839 26.3761 5.5 22 5.5C17.6239 5.5 13.4271 7.23839 10.3327 10.3327C7.23839 13.4271 5.5 17.6239 5.5 22C5.5 24.1668 5.92678 26.3124 6.75599 28.3143C7.58519 30.3161 8.80057 32.1351 10.3327 33.6673C11.8649 35.1994 13.6839 36.4148 15.6857 37.244C17.6876 38.0732 19.8332 38.5 22 38.5C24.1668 38.5 26.3124 38.0732 28.3143 37.244C30.3161 36.4148 32.1351 35.1994 33.6673 33.6673C35.1994 32.1351 36.4148 30.3161 37.244 28.3143Z",
		stroke: "currentColor",
		strokeWidth: 3.66667,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M22 27.499L16.5861 30.42C16.0379 30.7158 15.3939 30.2366 15.5196 29.6266L16.7202 23.8016L12.2229 19.7932C11.75 19.3717 11.9981 18.5891 12.6276 18.5172L18.7365 17.8188L21.3385 12.3821C21.6045 11.8265 22.3955 11.8265 22.6615 12.3821L25.2635 17.8188L31.3724 18.5172C32.0019 18.5891 32.25 19.3717 31.7771 19.7932L27.2798 23.8016L28.4804 29.6266C28.6061 30.2366 27.9621 30.7158 27.4139 30.42L22 27.499ZM22 25.3697L26.0933 27.5779L25.1787 23.1438L28.6224 20.0735L23.9643 19.5412L22 15.436L20.0357 19.5421L15.3776 20.0735L18.8213 23.1438L17.9067 27.5779L22 25.3697Z",
		fill: "currentColor",
		stroke: "currentColor",
		strokeWidth: 1.28333
	})]
});
export default SvgFavCircle;
